import React from 'react';
import { createForm } from 'rc-form';
import { Picker, List, InputItem, WhiteSpace, Toast, Button, WingBlank } from 'antd-mobile';

import { ImgUpload } from '@common/img-upload/ImgUpload';
import { getAppId, checkIfLogin } from '@utils/global';
import { appMethod as app } from '@utils/app';
import { ajax } from '@utils/http';
import { TopNav } from '@common/top-nav/TopNav';
import './UserInfoPage.less';

const UserAvatar = (props) => (
  <div className="user-avator">
    <img src={props.url}/>
    <ImgUpload complete={(url) => props.change(url)}/>
  </div>
)

class UserInfoPage extends React.Component {
  state = {
    isLoading: false
  }
  sexPickerData = [
    {
      label: '男',
      value: 'man'
    },
    {
      label: '女',
      value: 'woman'
    }
  ];
  constructor(props) {
    super(props);
    document.title = '我的';
  }
  componentDidMount() {
    if (!app.isLogin()) {
      if (app.globalData.currentPages.length > 1) {
        this.turnToPage('loginPage', {}, 1);
      } else {
        this.turnToPage('loginPage');
      }
      return;
    }
    this.getUserInfo();
  }
  /**
   * 处理用户信息
   */
  getUserInfo = () => {
    ajax({
      url: '/index.php?r=AppData/getUserInfo',
      type: 'get',
      data: {
        app_id: getAppId(),
      },
      success: (res) => {
        let info = res.data;
        let state = {
          avatar: info.cover_thumb || 'http://cdn.jisuapp.cn/static/webapp/images/default_photo.png',
          nickname: info.nickname || null,         
          phone: info.phone || null
        }
        if (info.sex) {
          state['sex'] = [info.sex === '0' ? 'man' : 'woman'];
        }
        this.props.form.setFieldsValue(state);
      }
    })
  }

  setAvatar = (url) => {
    this.props.form.setFieldsValue({
      avatar: url
    });
  }

  handleChangePhone = () => {
    app.turnToPage('bindPhonePage');
  }

  handleSave = () => {
    let valid = true;
    this.props.form.validateFields((errors) => {
      if (!errors) {
        return;
      }
      valid = false;
      for(let field in errors) {
        let error = errors[field].errors[0];
        if (error) {
          Toast.info(error.message);
          return;
        }
      }
    });
    if (!valid) {
      return;
    }
    this.setState({
      isLoading: true
    })
    let fieldsValue = this.props.form.getFieldsValue();
    ajax({
      url: '/index.php?r=AppData/saveUserInfo',
      type: 'post',
      data: {
        app_id: getAppId(),
        cover_thumb: fieldsValue['avatar'],
        nickname: fieldsValue['nickname'],
        sex: fieldsValue['sex'][0] === 'man' ? '0' : '1',
      },
      success: (res) => {
        this.setState({
          isLoading: false
        })
        if (res.status !== 0) {
          Toast.info('保存失败');
        }
        Toast.info('保存成功', 2);
      }
    });
  }

  logout = () => {
    ajax({
      url: '/index.php?r=AppUser/logout',
      data: {
        app_id: getAppId(),
      },
      success: () => {
        app.setIsLogin(false);
      }
    })
  }

  render() {
    const { getFieldProps, getFieldValue, isFieldsTouched } = this.props.form;
    return (
      <div id="userInfoPage" className="page" >
        <TopNav title="我的"/>
        <WhiteSpace />
        <List>
          <List.Item
            {...getFieldProps('avatar')}
            extra={<UserAvatar url={getFieldValue('avatar')} change={(url) => this.setAvatar(url)} {...this.props}/>}
            >我的头像</List.Item>
          <InputItem
            {...getFieldProps('nickname', {
              rules: [
                { required: true, message: '请填写昵称' }
              ]
            })}
            placeholder="填写昵称"
            name="nickname"
          >昵称</InputItem>
          <Picker
            title="选择性别"
            data={this.sexPickerData}
            cols={1}
            {...getFieldProps('sex')}>
            <List.Item arrow="horizontal">性别</List.Item>
          </Picker>
          <List.Item {...getFieldProps('phone')} extra={getFieldValue('phone')} arrow="horizontal" onClick={this.handleChangePhone}>手机号码</List.Item>
        </List>
        <WhiteSpace size="lg"/>
        <WingBlank size="lg">
          <Button type="primary" style={{ fontSize: '16px', height: '38px', lineHeight: '38px' }} disabled={this.state.isLoading || !isFieldsTouched()} loading={this.state.isLoading} onClick={this.handleSave}>保存</Button>
          <WhiteSpace />
          <Button type="default" style={{ fontSize: '16px', height: '38px', lineHeight: '38px' }} onClick={this.logout}>退出登录</Button>
        </WingBlank>
      </div>
    );
  }
}
export default createForm()(UserInfoPage);


// WEBPACK FOOTER //
// ./src/official-page/user-info-page/UserInfoPage.jsx